<template>
    <div class="register bg-light">
        <div class="register mx-1 pt-5 mb-5">
            <div class="mx-auto px-2 px-sm-4 kovatek-login border shadow-lg pt-2">
                <form class="py-3 px-md-2 mx-auto" @submit.prevent="signup">
                    <div class="">
                        <div class="row my-5 mx-0 px-0">
                            <div class="col-6 px-0">
                                <div class="border stage-box mx-auto" @click="clickedEmployer">
                                    <!-- <input type="radio" name="usertype" value="employer" v-model="usertype" /> -->
                                    <div class="mt-3">
                                        <font-awesome-icon class="kova-text ctrl-icon-size" icon="wifi" />
                                    </div>
                                    <div class="d-flex align-items-center mx-auto">
                                        <h6 class="kova-text font-weight-bolder mx-auto">Hire a Talent</h6>
                                        <font-awesome-icon icon="check-circle" class="checked" v-if="employer"></font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 px-1">
                                <div class="border stage-box mx-auto" @click="clickedDevs">
                                    <!-- <input type="radio" name="usertype" value="developer" v-model="usertype" /> -->
                                    <div class="mt-3">
                                        <font-awesome-icon class="kova-text ctrl-icon-size" icon="briefcase" />
                                    </div>
                                    <div class="d-flex align-items-center mx-auto">
                                        <h6 class="kova-text font-weight-bolder mx-auto">Work as a Talent</h6>
                                        <font-awesome-icon icon="check-circle" class="checked"  v-if="devs"></font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="my-3 mx-1 mx-sm-0">
                            <input type="email" class="form-control input-height" placeholder="Work Email Address" v-model="email" required/>
                        </div>
                        <div class="mb-3 mx-1 mx-sm-0">
                            <input type="password" class="form-control input-height" placeholder="Password" v-model="password" required/>
                        </div>
                        <div class="mb-3 mx-1 mx-sm-0">
                            <input type="password" class="form-control input-height" placeholder="Confirm Password" v-model="confirmPassword" required/>
                        </div>
                    </div>
                        <div class=" mt-3 mx-lg-5">
                            <div class="pb-5 pb-md-4 mx-1 mx-sm-0">
                                <label class="checkbox-label">
                                    <input type="checkbox" />
                                    <span class="checkbox-custom rectangular"></span><span class="mb-3 ml-4 text-left" style="font-size: 14px">
                                        By registering you confirm that you accept the <router-link to="/" class="font-weight-bold kova-text"><a>Terms and Conditions</a></router-link> and <router-link to="/" class="font-weight-bold kova-text"><a>Privacy Policy </a></router-link>
                                    </span>
                                </label> 
                            </div>
                            <!-- <div class="">
                                <p class="mt-3">By registering you confirm that you accept the <router-link to="/">Terms and Conditions</router-link> and <router-link to="/">Privacy Policy </router-link></p>
                            </div> -->
                        </div>
                        <div class="m-auto">
                            <!-- :disabled="{invalid}" -->
                            <button type="submit" class="btn btn-kovatek mt-3 w-100" >Sign Up</button>
                            <p class="text-danger font-weight-bolder my-2" v-if="error">{{error}}</p>
                        </div>
                        <!-- <a-divider /> -->
                        <div class="mt-4"></div>
                        <p>I have an account, I want to <router-link to="/login" class="font-weight-bold kova-text"><a>Log In</a></router-link> </p>
                </form>            
            </div>
        </div>
        <Footer />
    </div>
    
</template>
<script>

import Footer from '@/components/Footer.vue';

export default {
    name: 'register',
    components: {
        Footer
    },
    data(){
        return {
            employer: false,
            devs: false,
            email: "",
            password: "",
            confirmPassword:"",
            usertype: Number,
            message: null,
            error: null
        }
    },
    methods: {
        clickedEmployer(){
            this.devs = false;
            this.employer = true;
        },
        clickedDevs(){
            this.employer = false;
            this.devs = true
        },
        signup(){
            this.employer ? this.usertype = 2 : this.devs ? this.usertype = 1 : this.usertype = '';            
            const isValid = this.password !== this.confirmPassword || this.email === '' || this.password === '' || this.confirmPassword === '' || this.usertype === '';
            
                // console.log(isValid)
                if(!isValid){
                    const data = {
                                    email: this.email,
                                    password: this.password,
                                    user_type: this.usertype
                            }

                    // console.log(data)

                    this.$store.dispatch("signup", data)
                      .then((resp) => {
                          this.message = resp.data;
                        })
                      .catch(err => {
                        //   console.log(err)
                          this.error = err.message
                      });

                }else{
                    this.error = "invalid or incomplete inputs"

                }      
        }
    },
    computed: {
        // invalid: () => {
        //     const invalid = this.password === this.confirmPassword || this.email.length === '' || this.password === '' || this.confirmPassword === '' || this.userType === ''
        //     return invalid
        // },

        // user: () => {
        //     if(this.employer){
        //         const userType = "employer"
        //         return userType
        //      }
        //      if(this.devs){
        //         return this.userType = "developer"
        //      }
        // }

    },
    // watch: {
    //     invalid: {
    //         handler: (val) => {
    //             console.log(val)
    //         }
    //     }
    // }
}

</script>
<style scoped>
.kovatek-login{
    background: #fff;
    height: auto;
    width: 600px;
    border-radius: 10px;
}

.logo-size{
    height: 45px;
    width: 150px;
}

.add-grey{
    background-color:#ddd;
}
.add-grey:hover{
    background-color:#ccc;
}
.input-height{
    height: 50px;
    font-size: 13px;
    width: 100%;
}

.btn-kovatek{
  background-color: #20409A;
  height: 50px;
  color: #fff;
  transition: .25s;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.icon-size{
    font-size: 20px;
}
.stage-box{
    height: 100px;
    width: 170px;
    border-radius: 20px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover{
    background-color: #f1f1f1
}
.checked{
    position: absolute;
    left: 195px;
    font-size: 35px;
    bottom: 45px;
    color: #4BB38E;
}
.ctrl-icon-size{
    font-size: 35px;
}

@media (min-width: 768px) and (max-width: 991px){

}
@media (max-width: 767px){
.kovatek-login{
  width:400px;
} 
.input-height{
    font-size: 16px;
}
.stage-box{
        height:100px;
        width: 145px;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }
    .checked{
        position: absolute;
        left: 120px;
        font-size: 35px;
        bottom: 45px;
        color: #4BB38E;
    }
}

@media (max-width: 450px){
.kovatek-login{
  width:100%;
} 
.control-width{
        width:100%;
    }
    
}
</style>